export const PLAN_LIMITS: Record<string, number> = {
  basico: 20,
  pro: 60,
}

export const TRIAL_LIMIT = 5

export const CONTACT_EMAIL = 'contato@wedigital.pro'

export const CONTACT_EMAIL_URL = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  'Preciso de mais avaliações no WeAuto'
)}&body=${encodeURIComponent(
  'Olá! Atingi o limite de 60 avaliações do Plano Pro e gostaria de conversar sobre mais volume.'
)}`

export function getLimite(plano: string): number {
  return PLAN_LIMITS[plano] ?? 20
}
